<div #box class="metrix-configurator-container"></div>
